import PropTypes from 'prop-types';
import { useTranslation } from './useTranslation';
import { TextField, MenuItem } from '@mui/material';
import { themeColors } from '../theme/theme';

export function Input({ label, size = 'medium', select, options, SelectProps, ...props }) {
  const { t, language } = useTranslation();
  const translatedLabel = label ? t(label) : undefined;

  const isSelect = !!select;
  const mergedSelectProps = {
    MenuProps: { disablePortal: false },
    ...SelectProps,
  };

  return (
    <TextField
      label={translatedLabel}
      size={size}
      variant={isSelect ? 'outlined' : props.variant || 'outlined'}
      InputLabelProps={{
        style: { fontFamily: themeColors.fontFamily, fontSize: '1rem' },
        shrink: isSelect ? true : undefined, // Always show label for select
      }}
      inputProps={{
        style: { fontFamily: themeColors.fontFamily, fontSize: '1rem' },
        ...props.inputProps,
      }}
      style={{
        background: themeColors.backgroundColor,
        borderRadius: 6,
        margin: '0.5em 0',
      }}
      lang={language}
      select={select}
      SelectProps={
        isSelect
          ? {
              ...mergedSelectProps,
              onClose: (e) => {
                e.stopPropagation?.();
              },
            }
          : undefined
      }
      {...props}
      // Prevent form from being disabled on dropdown click
      onClick={(e) => {
        if (isSelect) e.stopPropagation();
        if (props.onClick) props.onClick(e);
      }}
    >
      {isSelect &&
        options &&
        options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
    </TextField>
  );
}

Input.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']), // Remove 'large' for MUI compatibility
  placeholder: PropTypes.string,
  label: PropTypes.string,
};
